import { render, staticRenderFns } from "./UserSettingsPlatformPreferences.vue?vue&type=template&id=ffd14c1e&scoped=true&"
import script from "./UserSettingsPlatformPreferences.vue?vue&type=script&lang=js&"
export * from "./UserSettingsPlatformPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd14c1e",
  null
  
)

export default component.exports